import ac from "../images/speakers/Ashish_Chauhan.png"
import by from "../images/speakers/Bhupendra_Yadav.jpg"
import cpr from "../images/speakers/CP_Radhakrishnan.jpg"
import gsm from "../images/speakers/Ganti_S_Murthy.jpg"
import gd from "../images/speakers/Gauranga-Das-Prabhu.png"
import sgm from "../images/speakers/S-Gurumurthy.png"
import hs from "../images/speakers/Hiten-Sethi.jpg"
import rns from "../images/speakers/Radhanath_swami.jpeg"
import vb from "../images/speakers/vardar.jpg"
import rk from "../images/speakers/Raman_Kant.jpg"
import gr from "../images/speakers/Ganesh_Ramakrishnan.jpg"

const CommitteeMembers = {
  advisory: [
    { name: 'HH Radhanath Swami', image: rns, designation: 'Spiritual Leader, Teacher, Author', link: 'https://www.radhanathswami.com/about-radhanath-swami/' },


    { name: 'Shri C P Radhakrishnan', image: cpr, designation: 'Hon. Governor of Maharashtra', link: 'https://en.wikipedia.org/wiki/C._P._Radhakrishnan' },
    { name: 'Prof. Ganti S Murthy', image: gsm, designation: 'IIT Indore, National Coordinator - IKS', link: 'https://iiti.irins.org/profile/113223' },

    { name: 'Shri Raman Kant', image: rk, designation: "President, Bharatiya Nadi Parishad", link: 'https://rivermanofindia.in/' },

    { name: 'Prof. Varadraj Bapat', image: vb, designation: 'IIT Bombay, SJMSOM', link: 'https://www.som.iitb.ac.in/prof-varadraj-bapat/' },
    { name: 'Prof. Ganesh Ramakrishnan', image: gr, designation: "Professor, IIT Bombay", link: 'https://www.cse.iitb.ac.in/~ganesh/' },
    { name: 'Ar. Hiten Sethi', image: hs, designation: 'Founder, HSA', link: 'https://www.linkedin.com/in/realhitensethi/' },
    { name: 'Shri S Gurumurthy', image: sgm, designation: 'CA, Corporate & Legal Adviser', link: 'https://en.wikipedia.org/wiki/Swaminathan_Gurumurthy' },
    { name: 'HG Gauranga Das', image: gd, designation: 'Director, Govardhan Ecovillage', link: 'https://gaurangadas.com/' },

  ]
};


export default CommitteeMembers;